import React from "react";
import MonacoEditor from "@monaco-editor/react";

export default function CodeEditor({ value, onChange, height = "100%", language = "javascript" }) {
  return (
    <div style={{ flex: 1, minHeight: 0 }}>
      <MonacoEditor
        height={height}
        width="100%"
        language={language}
        theme="vs-dark"
        value={value}
        onChange={onChange}
        options={{
          fontSize: 16,
          minimap: { enabled: false },
          wordWrap: 'on',
          scrollBeyondLastLine: false,
          automaticLayout: true,
          fontFamily: 'Fira Mono, monospace',
          lineNumbers: "on",
          roundedSelection: false,
          readOnly: false,
          cursorStyle: "line",
          scrollbar: {
            vertical: "auto",
            horizontal: "auto"
          },
          lineDecorationsWidth: 2,
          lineNumbersMinChars: 3,
          overviewRulerBorder: false,
          renderLineHighlight: "all",
          renderIndentGuides: true,
          tabSize: 2,
          padding: { top: 20, bottom: 20 }
        }}
      />
    </div>
  );
}
